import { render, staticRenderFns } from "./PaymentSuccessfulModalComponent.vue?vue&type=template&id=47e40b1e&"
import script from "./PaymentSuccessfulModalComponent.vue?vue&type=script&lang=ts&"
export * from "./PaymentSuccessfulModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports